<template>
  <Layout>
    <DataBox :loading="tryCheckKey">
      <SetPassword v-if="isValidKey" class="basic-wrapper form-wrapper" />
      <GetEmailLink v-else class="basic-wrapper form-wrapper" />
    </DataBox>
  </Layout>
</template>

<script>
import Layout from '@/layout/public'
import SetPassword from './SetPassword.vue'

import DataBox from '@/components/DataBox.vue'
import GetEmailLink from './GetEmailLink.vue'

import { AuthService } from '@/services/auth.service'

import syncQuery from '@/mixins/syncUrlQuery'

export default {
  name: 'Reset',
  page: {
    title: 'Восстановление пароля',
  },
  components: {
    Layout,
    SetPassword,
    GetEmailLink,
    DataBox,
  },
  mixins: [syncQuery],
  data() {
    return {
      tryCheckKey: false,
      isValidKey: false,
      email: '',
      key: '',
    }
  },
  async mounted() {
    this.syncQuery(['email', 'key'])

    this.isValidKey = await this.checkKey()
  },
  methods: {
    /**
     * Validate key string from url query parameter.
     * Hash string returns in email reset password link.
     */
    async checkKey() {
      this.tryCheckKey = true
      try {
        if (!this.email || !this.key) return false

        return await AuthService.checkKey({ email: this.email, key: this.key })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })

        return false
      } finally {
        this.tryCheckKey = false
      }
    },
  },
}
</script>
